// get the last segment of pathname
export const getSlug = (pathname = '') =>
  pathname.substring(pathname.lastIndexOf('/') + 1)
